import React from 'react';
import { Form, Input } from 'antd';
import { StepHeader } from '../StepHeader';

const { TextArea } = Input;

export const Step1Content: React.FC = () => (
  <div>
    <StepHeader
      stepNumber={1}
      title="Write the question"
      description="This is the exact prompt the candidate will see."
    />

    <Form.Item
      name="text"
      label="Question Text *"
      rules={[{ required: true, message: 'Question text is required' }]}
    >
      <TextArea
        autoSize={{ minRows: 3, maxRows: 6 }}
        placeholder="e.g. Have you ever been convicted of a felony?"
      />
    </Form.Item>
  </div>
);

export default Step1Content;
